export default __webpack_public_path__ + "static/media/kittycrossing.398fa97d.png";